import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { SITE_URL, getHeadValue, setHeadValue } from "../utils/seo";

// Per-route head overrides. Used on placeholder pages that should not be indexed:
// keeps them out of search results and points the canonical at the page itself
// (instead of the home page set in public/index.html).
const PageMeta = ({ noindex = false, selfCanonical = true }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const previousRobots = getHeadValue('meta[name="robots"]', "content");
    const previousCanonical = getHeadValue('link[rel="canonical"]', "href");
    const previousOgUrl = getHeadValue('meta[property="og:url"]', "content");

    if (selfCanonical) {
      const url = `${SITE_URL}${pathname}`;
      setHeadValue('link[rel="canonical"]', "href", url);
      setHeadValue('meta[property="og:url"]', "content", url);
    }
    if (noindex) {
      setHeadValue('meta[name="robots"]', "content", "noindex, follow");
    }

    return () => {
      if (previousRobots) {
        setHeadValue('meta[name="robots"]', "content", previousRobots);
      }
      if (previousCanonical) {
        setHeadValue('link[rel="canonical"]', "href", previousCanonical);
      }
      if (previousOgUrl) {
        setHeadValue('meta[property="og:url"]', "content", previousOgUrl);
      }
    };
  }, [pathname, noindex, selfCanonical]);

  return null;
};

export default PageMeta;
